import { render, staticRenderFns } from "./BodegaCrear.vue?vue&type=template&id=0ef2e910&scoped=true"
import script from "./BodegaCrear.vue?vue&type=script&lang=js"
export * from "./BodegaCrear.vue?vue&type=script&lang=js"
import style0 from "./BodegaCrear.vue?vue&type=style&index=0&id=0ef2e910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef2e910",
  null
  
)

export default component.exports